import { render, staticRenderFns } from "./JornadasDetails.vue?vue&type=template&id=341d230c"
import script from "./JornadasDetails.vue?vue&type=script&lang=js"
export * from "./JornadasDetails.vue?vue&type=script&lang=js"
import style0 from "./JornadasDetails.vue?vue&type=style&index=0&id=341d230c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports